module.exports = __webpack_public_path__ + "img/type-of-platform-vuforia.b15c17cc.webp";